import * as d3 from 'd3';
import {roundTo20} from '../../utils/math';
function render(g, node, isSelected) {
 
  // https://image.flaticon.com/icons/png/512/32/32390.png
  if (node.type === 'condition') {
    //const full = process.env.VUE_APP_DEFAULT_URL;
    node.width = node.width || 120;
    node.height = node.height || 120;
    
    g.append("svg:image")
    .attr('x', node.x)
    .attr('y', node.y)
    .attr('width', 120)
    .attr('height', 120)
    .attr("xlink:href", '/diamond.png')
    g.append('text').
          attr('x', node.x + 100).
          attr('y', node.y + 30).
          attr('class', 'unselectable').
          text(() => node.condition)
  } else {
    node.width = node.width || 120;
    node.height = node.height || 120;
    let borderColor = isSelected ? '#666666' : '#bbbbbb';
    if (node.type === 'operation') {
      // title
      g.append('rect').
          attr('x', node.x).
          attr('y', node.y).
          attr('stroke', borderColor).
          attr('class', 'title').
          style('height', '40px').
          style('fill', '#FFF').
          style('stroke-width', '2px').
          style('width', node.width + 'px');
      
      if (node.approvers.length > 0) {
        g.append('text').
            attr('x', node.x + 4).
            attr('y', node.y + 15).
            attr('class', 'unselectable').
          text(() => node.approvers[0].name).
            each(function wrap() {
              let self = d3.select(this),
                  textLength = self.node().getComputedTextLength(),
                  text = self.text();
              while (textLength > (node.width - 2 * 4) && text.length > 0) {
                text = text.slice(0, -1);
                self.text(text + '...');
                textLength = self.node().getComputedTextLength();
              }
            });      
      }
          
    }
    // body
    let body = g.append('rect').attr('class', 'body');
    body.style('width', node.width + 'px').
        style('fill', 'white').
        style('stroke-width', '2px');
    if (node.type === 'operation') {
      body.attr('x', node.x).attr('y', node.y + 20);
      body.style('height', roundTo20(node.height - 20) + 'px');
    } else {
      body.attr('x', node.x).
          attr('y', node.y).
          classed(node.type, true).
          attr('rx', 30);
      body.style('height', roundTo20(node.height) + 'px');
    }
    body.attr('stroke', borderColor);
  
    // body text
    let text = node.type === 'start'
        ? 'DEBUT'
        : (node.type === 'end' ? 'FIN' : (
                (!node.approvers || node.approvers.length === 0)
                    ? 'Acteur anonyme'
                    : (
                        node.approvers.length > 1
                            ? `${node.name + '...'}`
                            : node.name
                    )
            )
        );
    if (node.type === 'operation') {
      
      g.append("rect")
            .attr('x', node.x + 20)
            .attr('y', node.y + 30)
            .attr('width', 80)
            .attr('height', 80)
            .style('fill', '#f1f5fa')
      // render image inside node
      if (node.approvers.length > 0) {
        if (node.approvers[0].url !== null) {      
          g.append("svg:image")
            .attr('x', node.x + 20)
            .attr('y', node.y + 30)
            .attr('width', 80)
            .attr('height', 80)
            .attr(
              "xlink:href", process.env.VUE_APP_IMAGE_URL + node.approvers[0].url)
        } else {
          g.append("svg:image")
          .attr('x', node.x + 20)
          .attr('y', node.y + 30)
          .attr('width', 80)
          .attr('height', 80)
          .attr(
            "xlink:href", 
            "/user.jpg"
          )
        }
      } else {
        g.append("svg:image")
          .attr('x', node.x + 20)
          .attr('y', node.y + 30)
          .attr('width', 80)
          .attr('height', 80)
          .attr(
            "xlink:href", 
            "/user.jpg"
          )
        
      }
    }
  
    let bodyTextY;
    
    if (node.type === 'operation') {
      bodyTextY =  node.y + 145;
    } else {
      bodyTextY = node.y + 5 + roundTo20(node.height) / 2;
    }
    // render an image placeholver
      /* eslint-disable no-console */
    // render text inside node
    g.append('text').
        attr('x', node.x + node.width / 2).
        attr('y', bodyTextY).
        attr('class', 'unselectable').
        attr('text-anchor', 'middle').
        text(function() {return text;})
  }
}

export default render;